import API from "../../services/api";
import { normalizeApiError } from "../../utils/normalizeApiError";

function publicError(err) {
  const msg = normalizeApiError(err);
  const lower = String(msg || "").toLowerCase();
  if (
    !msg
    || lower.includes("internal server error")
    || lower.includes("traceback")
    || lower.includes("sqlalchemy")
    || lower === "500"
  ) {
    return "Something went wrong. Please try again.";
  }
  if (lower.includes("not a valid email")) {
    return "Enter a valid work email.";
  }
  if (lower.includes("too many requests")) {
    return "Please wait a moment and try again.";
  }
  return msg;
}

export const submitDemoEnquiry = async (payload) => {
  try {
    const { data } = await API.post("/demo/enquiries", payload);
    return data;
  } catch (err) {
    throw new Error(publicError(err));
  }
};

export const fetchDemoEnquiry = async (token) => {
  try {
    const { data } = await API.get(`/demo/enquiries/${encodeURIComponent(token)}`);
    return data;
  } catch (err) {
    throw new Error(publicError(err));
  }
};

export const fetchAvailableSlots = async (date) => {
  try {
    const { data } = await API.get("/demo/available-slots", { params: { date } });
    return data;
  } catch (err) {
    throw new Error(publicError(err));
  }
};

export const confirmDemoBooking = async (payload) => {
  try {
    const { data } = await API.post("/demo/bookings", payload);
    return data;
  } catch (err) {
    throw new Error(publicError(err));
  }
};
